export const createId = (prefix: string) => `${prefix}_${crypto.randomUUID()}`;
